import { Geometry } from 'ol/geom';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { BgisLegendLayerDetails, BgisLegendEntry  } from '../../bgis/components/maparea/sidebar/menus/legend';
import { BasemapSource } from '../../bgis/ol';
import { basemapGrayLayer, basemapOrthofotoLayer, noBasemapLayer, digitaleKatastralmappeLayer, adminLayer, wertvolleLandwBoedenLayer } from '../layers';
import admIcon from '../../img/legend/adm.svg';
import dkmIcon from '../../img/legend/dkm.svg';
import selectedGstkIcon from '../../img/legend/selectedGstk.svg';
import wertvolleboedenIcon from '../../img/legend/wertvolleboeden.svg';

// test
export const LegendLayers: React.FC<{}> = () => {


    const toggleBasemapLayer = (layer2display: TileLayer<BasemapSource> | VectorLayer<VectorSource<Geometry>>) => {
        [basemapGrayLayer, basemapOrthofotoLayer, noBasemapLayer].forEach(layer => layer.setVisible(layer2display === layer));
    }


    return (
        <BgisLegendLayerDetails>
            <BgisLegendEntry icon={wertvolleboedenIcon} label="Wertvolle landwirtschaftliche Produktionsfläche"   ></BgisLegendEntry>


            <BgisLegendEntry icon={admIcon} label="Administrative Grenzen"  ></BgisLegendEntry>
            <BgisLegendEntry icon={dkmIcon} label="Katastralmappe"   ></BgisLegendEntry>

            <BgisLegendEntry icon={selectedGstkIcon} label='Ausgewählte(s) Grundstück(e)'></BgisLegendEntry>

        </BgisLegendLayerDetails>
    );
}